import React, { memo, useMemo } from 'react';

import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

import { selectedRowKeysSel } from '@modules/advancement/pendingItems/duck';
import { ApproveAdvancementsButton } from '@modules/progress/approveAdvancements';
import { Fab } from '@modules/shared';
import { hasNewPermissionSel } from '@shared/duck/selectors/general.selectors';
import { newPermissions } from '@shared/newPermissions';

import styles from './PendingItemsList.less';
import type { FlatListItem } from './PendingRequirementsList';

interface PendingRequirementsListFabProps {
  inline?: boolean;
  isOffline: boolean;
  items: FlatListItem[];
}

export const PendingRequirementsListFabOriginal: React.FC<
  PendingRequirementsListFabProps
> = ({ isOffline, items, inline }) => {
  const selectedRowKeys = useSelector(selectedRowKeysSel);
  const canApprove = useSelector(state =>
    hasNewPermissionSel(state, newPermissions.APPROVE_ADVANCEMENTS),
  );
  const selectedAdvancements = useMemo(
    () => items.filter(({ key }) => selectedRowKeys.includes(key)),
    [items, selectedRowKeys],
  );

  return (
    <Fab
      visible={canApprove && !isOffline && !isEmpty(selectedRowKeys)}
      className="Joyride__ReportFab"
      inline={inline}
    >
      <ApproveAdvancementsButton
        advancementStatus={null}
        className={styles.approveAdvancements}
        personsAdvancements={selectedAdvancements}
      />
    </Fab>
  );
};

export const PendingRequirementsListFab = memo(
  PendingRequirementsListFabOriginal,
);
